import script from "./PayPalCheckout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayPalCheckout.vue?vue&type=script&setup=true&lang=ts"

import "./PayPalCheckout.vue?vue&type=style&index=0&id=1a55be28&scoped=true&lang=css"
import "./PayPalCheckout.vue?vue&type=style&index=1&id=1a55be28&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a55be28"]])

export default __exports__